export const PRIMARY = '#40B9EB';
export const SECONDARY = '#00D6CE';
export const RED = '#ED6D48';
export const GREEN = '#42B549';
export const ORANGE = '#FF7B00';
